import { PropsWithChildren, useEffect } from "react";
import { useAuth } from "./AuthProvider";
import { useNavigate } from "react-router-dom";
import { ROLE } from "../../utils/roles";

type ProtectedRouteProps = PropsWithChildren & {
    roles: Array<ROLE>
};

export default function ProtectedRoute({ children, roles }: ProtectedRouteProps): JSX.Element {

    const user = useAuth()
    const navigate = useNavigate()

    useEffect(() => {

        if (user === null || user === undefined || Object.keys(user).length === 0) {
            console.log('1')
            return navigate('/login', { replace: true })
        }

        if (user.roles === undefined) {
            console.log('2')
            return navigate('/login', { replace: true })
        }

        const role = roles.filter(r => user.roles?.includes(r))

        if (role.length === 0) {
            console.log('3')
            return navigate('/login', { replace: true })
        }

    }, [navigate, user])

    return <>{children}</>
}